module.exports = __webpack_public_path__ + "img/galeria_stack_2.f83aad11.png";